import BaseDialog from '../../../../components/Dialogs/BaseDialog';
import { Button } from '../../../../components/UI-CHAKRA/Button';
import { Flex } from '../../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../../components/UI-CHAKRA/Text';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (formulaId: number) => void;
  onCancel: () => void;
  formulaId: number;
}

const ConfirmDialog = ({ isOpen, onClose, onConfirm, onCancel, formulaId }: ConfirmDialogProps) => {
  return (
    <BaseDialog isOpen={isOpen} onClose={onClose} width="340px" persist={false}>
      <Flex flexDirection="column" gap="10px">
        <Text fontSize="18px" fontWeight="700" color="primary.main">
          Sua fórmula será removida
        </Text>
        <Text fontSize="14px" fontWeight="400" color="typography.darkest">
          Você não poderá desfazer essa <br /> ação. Deseja remover mesmo assim?
        </Text>
        <Flex justifyContent="space-between" gap="10px" mt="10px">
          <Button backgroundColor="primary.main" color="#FFD3DE" borderRadius="40px" onClick={onCancel} width="100%">
            Cancelar
          </Button>
          <Button
            backgroundColor="transparent"
            color="#FF6161"
            border="2px solid"
            borderColor="#FF6161"
            borderRadius="40px"
            onClick={() => onConfirm(formulaId)}
            width="100%"
          >
            Remover
          </Button>
        </Flex>
      </Flex>
    </BaseDialog>
  );
};

export default ConfirmDialog;
